<template>
  <ion-page>
    <ion-header>
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-button @click="cancel()">
            <ion-icon :icon="closeOutline"></ion-icon>
          </ion-button>
        </ion-buttons>
        <ion-title class="review-title">Scan Results</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content>
      <div class="result-content">
        <div class="slider" v-if="barcodeResult.images.length > 1">
          <div class="slides">
            <div id="slide-1" v-for="n of barcodeResult?.images" :key="n">
              <img :src="n" />
            </div>
          </div>
        </div>
        <div class="slider" v-if="barcodeResult.images.length == 1">
          <div class="slides">
            <div id="slide-2">
              <img :src="barcodeResult?.images[0]" />
            </div>
          </div>
        </div>
        <div class="product_info animate__animated animate__bounce">
          <div class="brand">By: {{ barcodeResult?.brand }}</div>
          <div class="header">{{ barcodeResult?.title }}</div>
          <div class="description">{{ barcodeResult?.description }}</div>
          <!-- <div class="description">
            <p v-for="(feature, idx) in barcodeResult?.features" :key="idx.toString()">
              {{ feature }}
            </p>
          </div> -->
          <ion-list v-if="isFromDB">
            <ion-item v-for="review in barcodeResult?.reviews" :key="review?.id">
              <product-review-component :review="review" />
            </ion-item>
          </ion-list>
        </div>
        <div class="action-btn" v-if="isFromDB && barcodeResult?.status === 'active'">
          <ion-button @click="onAddFav">
            <ion-icon :icon="favoriteIcon" slot="start"></ion-icon>
            Favorite this product
          </ion-button>
        </div>
        <ion-button
          disabled
          shape="round"
          expand="full"
          class="disable-btn"
          v-else-if="isFromDB && barcodeResult?.status === 'pending'"
        >
          Product Pending Review
        </ion-button>
        <div class="action-btn" v-else>
          <ion-button @click="addSuggestProduct">Suggest this product</ion-button>
        </div>
      </div>
    </ion-content>
  </ion-page>
</template>
<script setup lang="ts">
import { computed, defineProps, ref } from "vue";
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonContent,
  IonButtons,
  IonButton,
  IonIcon,
  IonTitle,
  IonList,
  IonItem,
  modalController,
} from "@ionic/vue";
import { heart, heartOutline } from "ionicons/icons";
import { closeOutline } from "ionicons/icons";
import { useUserStore } from "@/store/modules/user";
import { useBrandStore } from "@/store/modules/brand";
import { useProductStore } from "@/store/modules/product";
import ProductReviewComponent from "@/components/Product/ProductReviewComponent.vue";
import { presentToastWithOptions, toDataURL } from "@/utils/functions";
import { useFavorite } from "@/hooks/useFavorite";

const props = defineProps(["barcodeResult", "isFromDB"]);
const isLoading = ref(false);
const userStore = useUserStore();
const productStore = useProductStore();
const brandStore = useBrandStore();
const { favorite, onAddFavorite, onDeleteFavorite, getFavorite } = useFavorite();
const user = computed(() => userStore.user);
const isFav = computed(() => favorite.value?.id ?? false);
const favoriteIcon = computed(() => (isFav.value ? heart : heartOutline));
const favoriteId = computed(() => favorite.value?.id);
const data = computed(() => {
  return {
    type: "product",
    product: "id" || "",
    user: user.value,
  };
});

const cancel = () => modalController.dismiss(false, "cancel");

const addSuggestProduct = async () => {
  isLoading.value = true;
  const brand_result = await brandStore.axCreateBrand({
    name: props.barcodeResult?.brand,
  });

  if (brand_result) {
    // toDataURL(props.barcodeResult?.images[0], (result: any) =>
    //   console.log("url-result==>", result)
    // );
    const data = {
      title: props.barcodeResult?.title,
      sku: props.barcodeResult?.barcode_number,
      url: props.barcodeResult?.images[0],
      description: props.barcodeResult?.description,
      brand: brand_result,
      status: "active",
    };
    const product_result = await productStore.axCreateProduct(data, userStore.user.id);
    isLoading.value = false;
    if (product_result) modalController.dismiss(true, "ok");
    else presentToastWithOptions("Creating the Suggested Product is failed", "danger");
  } else {
    isLoading.value = false;
  }
};

const onAddFav = async () => {
  if (!isFav.value) {
    await onAddFavorite(data.value);
  } else {
    await onDeleteFavorite(favoriteId.value || "", data.value?.type);
  }
  await getFavorite(data.value);
};
</script>

<style scoped lang="scss">
@import "../../theme/variables/typography";
* {
  box-sizing: border-box;
}

.result-content {
 
  overflow-y: auto;
}

.slider {
  width: 100vw;
  padding: 20px 0;
  text-align: center;
  overflow: hidden;
}

.slides {
  display: flex;

  overflow-x: auto;
  scroll-snap-type: x mandatory;

  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;

  /*
  scroll-snap-points-x: repeat(300px);
  scroll-snap-type: mandatory;
  */
}
.slides::-webkit-scrollbar {
  // width: 10px;
  height: 4px;
}
.slides::-webkit-scrollbar-thumb {
  background: rgba(34, 34, 34, 0.38);
  border-radius: 10px;
}
.slides::-webkit-scrollbar-track {
  background: transparent;
}
.slides > div {
  scroll-snap-align: start;
  flex-shrink: 0;
  width: 300px;
  height: 300px;
  margin-right: 50px;
  border-radius: 10px;
  background: #eee;
  transform-origin: center center;
  transform: scale(1);
  transition: transform 0.5s;
  position: relative;

  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 100px;
}
#slide-2 {
  margin-left: 1250px;
}

.author-info {
  background: rgba(0, 0, 0, 0.75);
  color: white;
  padding: 0.75rem;
  text-align: center;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  margin: 0;
}
.author-info a {
  color: white;
}
img {
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.slider > a {
  display: inline-flex;
  width: 1.5rem;
  height: 1.5rem;
  background: white;
  text-decoration: none;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  margin: 0 0 0.5rem 0;
  position: relative;
}
.slider > a:active {
  top: 1px;
}
.slider > a:focus {
  background: #b96b6b;
}

.disable-btn {
  margin: 20px 25px;
  text-transform: capitalize;
  --background: rgba(34, 34, 34, 0.38);
}

// /* Don't need button navigation */
// @supports (scroll-snap-type) {
//   .slider > a {
//     display: none;
//   }
// }

html,
body {
  height: 100%;
  overflow: hidden;
}
body {
  display: flex;
  align-items: center;
  justify-content: center;
  // background: linear-gradient();
  background: linear-gradient(to bottom, #74abe2, #5563de);
  font-family: "Ropa Sans", sans-serif;
}
.product_info {
  background-color: #fff;
  padding: 0px 25px;
  & .header {
    flex: 2;
    @include text-16-bold;
    font-weight: bold;
    line-height: 24px;
    padding: 0;
    margin-top: 8px;
  }
  & .brand {
    // font-style: italic;
    @include text-14-400;
    line-height: 25px;
    color: #848484;
  }

  .description {
    color: #848484;
    & p {
      margin: 8px 0px;
      &::before {
        content: "\00B7 ";
        // font-size: 30px;
        margin-right: 16px;
        font-weight: 600;
        color: #222;
      }
    }
  }

  ion-list {
    padding: 12px 25px;

    & ion-item {
      --inner-padding-end: 0px;
      margin-bottom: 15px;
    }
  }
}
</style>
